<!-- Template -->
<div class="node-details-container overflow-auto">
  <mat-card class="mat-elevation-z2 main-card shadow-none">
    <mat-card-content class="pt-1 px-2">

      <section class="node-overview">
        <h2>Overview</h2>
        <div class="info-grid-overview">
          <div class="info-item">
            <mat-icon>cloud</mat-icon>
            <div class="info-content">
              <span class="label">Deployment Name</span>
              <span class="value">{{ application.depName || "NA" }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>flag</mat-icon>
            <div class="info-content">
              <span class="label">Node Group</span>
              <span class="value">{{ application?.applicationNodeGroups || "NA" }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>schedule</mat-icon>
            <div class="info-content">
              <span class="label">License Check</span>
              <span class="value">{{ application.checkLicense | boolToString }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>receipt_long</mat-icon>
            <div class="info-content">
              <span class="label">Date Added</span>
              <span class="value">{{ application.dateAdded || "NA" }}</span>
            </div>
          </div>
        </div>
      </section>

      <mat-divider *ngIf="customActions.length > 0"></mat-divider>

      <section class="custom-actions" *ngIf="customActions.length > 0">
        <h2 class="mb-2">Custom Actions</h2>

        <table class="table table-hover">
          <thead>
            <tr class="table-list-head">
              <th>Action Name</th>
              <th>Script</th>
              <th>Params</th>
              <th>State</th>
              <th>Stage</th>
              <th>Status</th>
              <th>Options</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr class="table-list-row" *ngFor="let action of customActions; let i = index" style="z-index: 1 !important">
              <td>{{ action.actionName }}</td>
              <td>{{ action.script }}</td>
              <td>
                <select name="param" id="param" class="customActionSelect">
                  <option *ngFor="let s of action.param.split(',')" [value]="s">{{s.slice(1)}}</option>
                </select>
              </td>
              <td>
                <select name="state" id="state" class="customActionSelect">
                  <option *ngFor="let s of action.state.split(',')" [value]="s">{{s}}</option>
                </select>
              </td>
              <td>
                {{action.stage}}
              </td>
              <td>
                <select name="status" id="status" class="customActionSelect">
                  <option *ngFor="let s of action.status.split(',')" [value]="s">{{s}}</option>
                </select>
              </td>
              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <a class="optionBtn" style="z-index: 2" (click)="optionsForActions(action, 'edit')">
                    <mat-icon class="fs-4">edit</mat-icon>
                  </a>
                  
                  <a class="optionBtn text-danger" style="z-index: 2" (click)="optionsForActions(action, 'delete')">
                    <mat-icon class="fs-4">delete</mat-icon>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <mat-divider></mat-divider>

      <section class="additional-information">
        <h2>Additional Information</h2>
        <div class="info-grid-compact">
          <div class="info-item-compact">
            <span class="label">Name</span>
            <span class="value">{{ application.appName }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Version</span>
            <span class="value">{{ application.appVersionText }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Date Added</span>
            <span class="value">{{ application.dateAdded }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Deployment Name</span>
            <span class="value">{{ application.depName }}</span>
          </div>

          <!-- Conditional sections for non-type-2 applications and global admin -->
          <ng-container *ngIf="application.applicationType != '2'">
            <div class="info-item-compact">
              <span class="label">MPI</span>
              <span class="value">{{ application.mpi }}</span>
            </div>
            <div class="info-item-compact">
              <span class="label">Modules</span>
              <span class="value">{{ (application.modules || 'NA') }}</span>
            </div>
            <div class="info-item-compact">
              <span class="label">Fabric</span>
              <span class="value">{{ application.fabric }}</span>
            </div>
            <div class="info-item-compact">
              <span class="label">License Status</span>
              <span class="value">NA</span>
            </div>
            <div class="info-item-compact">
              <span class="label">License Check</span>
              <span class="value">{{ application.checkLicense | boolToString }}</span>
            </div>
            <div class="info-item-compact">
              <span class="label">Required Licenses</span>
              <span class="value">{{ application.reqLicenses || 'NA'}}</span>
            </div>
            <div class="info-item-compact">
              <span class="label">License Server</span>
              <span class="value">{{ application.reqLicenses || 'NA'}}</span>
            </div>
            <div class="info-item-compact">
              <span class="label">Default memory space</span>
              <span class="value">{{ application?.memoryPerCPU || 'NA'}}</span>
            </div>

            <!-- License File Section -->
            <div class="info-item-compact">
              <span class="label">License File <i title="Edit file" style="color: var(--s-primary-color); margin-left: .3rem; cursor: pointer;" (click)="showMessageDialog('License File')" class="bi bi-pencil-square"></i></span>
              <select class="form-select" *ngIf="multiLicenseFile.length != 0 && multiLicenseFile[0] != null" (change)="updateLicenseFile($event)">
                <option value="licenseFile" *ngFor="let licenseFile of multiLicenseFile">{{ licenseFile }}</option>
              </select>
              <label *ngIf="multiLicenseFile[0] == null">NA</label>
            </div>

            <!-- Execute Scripts Section -->
            <div class="info-item-compact">
              <span class="label">Execute Scripts <i title="Edit file" style="color: var(--s-primary-color); margin-left: .3rem; cursor: pointer;" (click)="showMessageDialog('Execute File')" class="bi bi-pencil-square"></i></span>
              <select class="form-select" *ngIf="multiExeFile.length != 0 && multiExeFile[0] != null" (change)="updateExeFile($event)">
                <option value="exeFile" *ngFor="let exeFile of multiExeFile">{{ exeFile }}</option>
              </select>
              <label *ngIf="multiExeFile[0] == null">NA</label>
            </div>

            <!-- Cancel Scripts Section -->
            <div class="info-item-compact">
              <span class="label">Cancel Scripts <i title="Edit file" style="color: var(--s-primary-color); margin-left: .3rem; cursor: pointer;" (click)="showMessageDialog('Cancel File')" class="bi bi-pencil-square"></i></span>
              <select class="form-select" *ngIf="multiCancelFile.length != 0 && multiCancelFile[0] != null" (change)="updateCancelFile($event)">
                <option value="cancelFile" *ngFor="let cancelFile of multiCancelFile">{{ cancelFile }}</option>
              </select>
              <label *ngIf="multiCancelFile[0] == null">NA</label>
            </div>

            <!-- Suspend Scripts Section -->
            <div class="info-item-compact">
              <span class="label">Suspend Scripts <i title="Edit file" style="color: var(--s-primary-color); margin-left: .3rem; cursor: pointer;" (click)="showMessageDialog('Suspend File')" class="bi bi-pencil-square"></i></span>
              <select class="form-select" *ngIf="multiSuspendFile.length != 0 && multiSuspendFile[0] != null" (change)="updateSuspendFile($event)">
                <option value="suspendFile" *ngFor="let suspendFile of multiSuspendFile">{{ suspendFile }}</option>
              </select>
              <label *ngIf="multiSuspendFile[0] == null">NA</label>
            </div>

            <!-- Resume Scripts Section -->
            <div class="info-item-compact">
              <span class="label">Resume Scripts <i title="Edit file" style="color: var(--s-primary-color); margin-left: .3rem; cursor: pointer;" (click)="showMessageDialog('Resume File')" class="bi bi-pencil-square"></i></span>
              <select class="form-select" *ngIf="multiResumeFile.length != 0 && multiResumeFile[0] != null" (change)="updateResumeFile($event)">
                <option value="resFile" *ngFor="let resFile of multiResumeFile">{{ resFile }}</option>
              </select>
              <label *ngIf="multiResumeFile[0] == null">NA</label>
            </div>

            <!-- Graph Scripts Section -->
            <div class="info-item-compact">
              <span class="label">Graph Scripts <i title="Edit file" style="color: var(--s-primary-color); margin-left: .3rem; cursor: pointer;" (click)="showMessageDialog('Graph File')" class="bi bi-pencil-square"></i></span>
              <select class="form-select" *ngIf="multiGraphFiles.length != 0 && multiGraphFiles[0] != null" (change)="updateGraphFile($event)">
                <option [value]="graphFile" *ngFor="let graphFile of multiGraphFiles">{{ graphFile }}</option>
              </select>
              <label *ngIf="multiGraphFiles[0] == null">NA</label>
            </div>

            <!-- Custom Scripts Seciton-->
            <div class="info-item-compact">
              <span class="label">Custom Action Scripts <i title="Edit file" style="color: var(--s-primary-color); margin-left: .3rem; cursor: pointer;" (click)="showMessageDialog('CustomActionFile')" class="bi bi-pencil-square"></i></span>
              <select class="form-select" *ngIf="multiCustomActionFiles.length != 0 && multiCustomActionFiles[0] != null" (change)="updateGraphFile($event)">
                <option [value]="customActionFile" *ngFor="let customActionFile of multiCustomActionFiles">{{ customActionFile }}</option>
              </select>
              <label *ngIf="multiCustomActionFiles[0] == null">NA</label>
            </div>

            <!-- Additional Info -->
            <div class="info-item-compact">
              <span class="label">Static cores</span>
              <span class="value">{{ application.staticCores || 'NA'}}</span>
            </div>
            <div class="info-item-compact">
              <span class="label">Assigned Node Groups</span>
              <span class="value">{{ application?.applicationNodeGroups || 'NA'}}</span>
            </div>
          </ng-container>
        </div>
      </section>

    </mat-card-content>
  </mat-card>
</div>
